import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Styled Components (Adjust as needed)
const HomePageContainer = styled.div`
  font-family: sans-serif;
  background-color: #f0f5ff; /* Light blue background */
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeroSection = styled.div`
  text-align: center;
  max-width: 600px;
`;

const HeroTitle = styled.h1`
  font-size: 3em;
  margin-bottom: 20px;
  color: #333;
`;

const HeroSubtitle = styled.p`
  font-size: 1.2em;
  margin-bottom: 30px;
  color: #555;
`;

const HeroButton = styled.button`
  background-color: #007bff;
  color: white;
  padding: 15px 30px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
`;

const AboutSection = styled.section`
  padding: 50px 20px;
  max-width: 800px;
  text-align: center;
`;

const FeaturesSection = styled.section`
  padding: 50px 20px;
  max-width: 800px;
  text-align: center;
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
`;

const FeatureItem = styled.li`
  margin-bottom: 15px;
`;

const Footer = styled.footer`
  background-color: #333;
  color: white;
  text-align: center;
  padding: 20px;
`;

function HomePage() {
  return (
    <HomePageContainer>
      <HeroSection>
		<HeroTitle>Design, Build, and Optimize Your Infrastructure</HeroTitle>
		<HeroSubtitle>Simplify your network with our AI-powered platform.</HeroSubtitle>
		<Link to="/signup"><HeroButton style={{ marginRight: '16px' }}>Get started</HeroButton></Link>
		<Link to="/login"><HeroButton>Login</HeroButton></Link>
	  </HeroSection>

      <AboutSection>
        <p>Relais empowers infrastructure engineers to design, build, and optimize their networks with ease. Our platform leverages AI to provide intelligent recommendations and automate complex configurations.</p>
      </AboutSection>

      <FeaturesSection>
        <h2>Key Features</h2>
        <FeatureList>
		  <FeatureItem>Manual Process Of Design</FeatureItem>
          <FeatureItem>AI-Powered Assistant For Design</FeatureItem>
          <FeatureItem>Automated Configuration</FeatureItem>
        </FeatureList>
      </FeaturesSection>


      <Footer>
        <p>&copy; {new Date().getFullYear()} Relais. All rights reserved.</p>
      </Footer>
    </HomePageContainer>
  );
}

export default HomePage;